import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useApisAnalyticsPlansKnowledgeInsightPostsIndex,
  useDateRange,
  useMultiDivisionMultiSectionDropdown,
  useProvidersCurrentEmployee,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { AnalyticsKnowledgeInsightPostsTemplate } from "~/components/templates";

const today = new Date();

export const AnalyticsPlansKnowledgeInsightPostsIndex: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const breadCrumbItems = [
    {
      label: "ナレッジシェア分析",
      href: "/analytics_plans/knowledge_insight_posts",
    },
  ];

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
  } = useMultiDivisionMultiSectionDropdown({
    selectableDivisions: currentEmployee?.businessDivisions,
    selectableSections: currentEmployee?.businessSections,
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      dateArray,
      formattedEndDate,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const { data, isLoading } = useApisAnalyticsPlansKnowledgeInsightPostsIndex({
    params: {
      businessDivisionIds: selectedDivisions.map((division) => division.id),
      businessSectionIds: optionSelectedSections.map((section) => section.id),
      createdAtFrom: formattedStartDate || undefined,
      createdAtTo: formattedEndDate || undefined,
    },
    config: {
      enabled: !!(formattedStartDate && formattedEndDate),
    },
  });

  return (
    <>
      <EmployeeLayout
        withRightSidebar={false}
        breadCrumbItems={breadCrumbItems}
      >
        <EmployeeLayoutMainContent withRightSidebar={false}>
          <AnalyticsKnowledgeInsightPostsTemplate
            formattedStartDate={formattedStartDate}
            formattedEndDate={formattedEndDate}
            selectedDivisions={selectedDivisions}
            optionSelectedSections={optionSelectedSections}
            data={data}
            isLoading={isLoading}
            onChangeDateRange={onChangeDateRange}
            onDivisionChange={onDivisionChange}
            onSectionChange={onSectionChange}
            selectableDivisions={selectableDivisions}
            optionSelectableSections={optionSelectableSections}
            startDate={startDate}
            endDate={endDate}
            selectedDropdownSections={optionSelectedSections}
            dateArray={dateArray}
          />
        </EmployeeLayoutMainContent>
      </EmployeeLayout>
    </>
  );
};
